import styled from 'styled-components';

export const StatusText = styled.span`
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`;
